export default "__VITE_ASSET__5XQ9gP4o__"